import { Link } from "react-router-dom";
import { TopBar, Footer, LOGO_URL } from "@/components/sections";

const Landing = () => (
  <main
    data-testid="landing-page"
    className="relative min-h-[100dvh] w-full overflow-x-hidden flex flex-col"
    style={{ backgroundColor: "var(--ld-ivory)" }}
  >
    <TopBar />

    {/* HERO */}
    <section
      data-testid="hero-section"
      className="relative flex min-h-[88dvh] md:min-h-[92dvh] flex-col items-center justify-center px-6 md:px-12 pb-24"
    >
      {/* Decorative corners */}
      <div className="pointer-events-none absolute left-6 top-24 hidden md:block ld-fade-in">
        <div className="flex items-center gap-3 text-[var(--ld-ink-muted)]">
          <div className="h-px w-10 bg-[var(--ld-gold)]/60" />
        </div>
      </div>
      <div className="pointer-events-none absolute right-6 top-24 hidden md:block ld-fade-in">
        <div className="flex items-center gap-3 text-[var(--ld-ink-muted)]">
          <div className="h-px w-10 bg-[var(--ld-gold)]/60" />
        </div>
      </div>

      {/* Logo */}
      <div
        data-testid="hero-logo-wrap"
        className="ld-fade-up flex flex-col items-center"
        style={{ animationDelay: "80ms" }}
      >
        <img
          data-testid="hero-logo"
          src={LOGO_URL}
          alt="Luxé Directory"
          className="w-[240px] sm:w-[280px] md:w-[320px] lg:w-[360px] h-auto select-none"
          draggable={false}
        />
      </div>

      {/* Gold rule */}
      <div
        className="ld-fade-up h-px w-28 md:w-40 ld-gold-rule mt-8"
        style={{ animationDelay: "280ms" }}
      />

      {/* Tagline */}
      <h1
        data-testid="hero-tagline"
        className="ld-fade-up font-serif-display text-center mt-8 text-3xl sm:text-4xl md:text-5xl lg:text-[58px] leading-[1.05] tracking-tight text-[var(--ld-ink)] max-w-[22ch] md:max-w-[26ch] font-medium"
        style={{ animationDelay: "420ms" }}
      >
        Bridging couples and premium vendors,
        <span className="italic text-[var(--ld-gold-deep)]"> all in one place.</span>
      </h1>

      <p
        data-testid="hero-subcopy"
        className="ld-fade-up mt-6 max-w-xl text-center text-[15px] md:text-base leading-relaxed text-[var(--ld-ink-muted)]"
        style={{ animationDelay: "560ms" }}
      >
        A directory of the finest people in the trade — built so you
        never have to search in ten places again.
      </p>

      {/* CTA — couples and vendors both start at /signin, which then
          routes through /choose-role after authentication. */}
      <div
        data-testid="hero-ctas"
        className="ld-fade-up mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4"
        style={{ animationDelay: "700ms" }}
      >
        <Link
          to="/signin"
          data-testid="hero-cta-signup"
          className="group inline-flex items-center justify-center h-12 px-10 text-[13px] tracking-[0.18em] uppercase font-accent bg-[var(--ld-ink)] text-[var(--ld-ivory)] border border-[var(--ld-ink)] transition-colors duration-500 hover:bg-[var(--ld-gold-deep)] hover:border-[var(--ld-gold-deep)]"
        >
          Sign up
        </Link>
      </div>
    </section>

    <Footer />
  </main>
);

export default Landing;
